import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { Rental } from '~types/rental.type';

export interface RentalResponse {
  rental: Rental | null;
}

export const useQueryGetOngoingRental = (
  options?: Omit<
    UseQueryOptions<
      RentalResponse,
      AxiosError<Record<string, string>>,
      RentalResponse,
      QUERY_KEY[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getOngoingRental = (): Promise<RentalResponse> =>
    getRequest({
      path: 'api/rental/active-rental',
    });

  return useQuery([QUERY_KEY.GET_ONGOING_RENTAL], () => getOngoingRental(), {
    enabled: !!inMemoryJWTService.getCurrentToken(),
    ...options,
  });
};
